<template>
  <div class="radio-buttons">
    <template v-for="item in items">
      <div
        v-if="item.value === value"
        :key="item.value"
        class="radio-button radio-button--active"
      >
        {{ item.name }}
      </div>
      <div
        v-else
        :key="item.value"
        class="radio-button"
        @click="$emit('change', item.value)"
      >
        {{ item.name }}
      </div>
    </template>
  </div>
</template>

<script>
export default {
  model: {
    event: 'change'
  },
  props: {
    value: {
      required: false,
      default: null
    },
    items: {
      type: Array,
      required: false,
      default: () => ([])
    }
  },
  mounted() {
    this.$el.style['grid-template-columns'] = `repeat(${this.items.length}, 1fr)`
  }
}
</script>

<style scoped>
.radio-buttons {
  display: grid;
  border-radius: 0.125em;
  border: 1px solid #1f65b5;
  color: #38b2ac;
}

.radio-button {
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: 0.125em;
  padding-bottom: 0.125em;
  font-size: 0.75em;
  cursor: pointer;
}

.radio-button:hover {
  color: #319795;
}

.radio-button--active {
  font-size: 0.75em;
  background-color: #1f65b5;
  color: #e6fffa;
  cursor: default;
}

.radio-button--active:hover {
  color: #e6fffa;
}
</style>
